<template>
  <div class="row d-flex align-items-center">
    <div class="col">
      <input
        type="text"
        class="form-control"
        placeholder="Search..."
        v-model.trim="search"
      />
    </div>
    <div class="col">Total: {{ sorted_players.length }}</div>
    <div class="col">
      Duplicates:
      <span class="text-danger fw-bold" v-if="duplicateNameCount">{{
        duplicateNameCount / 2
      }}</span>
      <span v-else>0</span>
    </div>
    <div class="col">PoolCaution: 42</div>
  </div>
  <ul class="list-group mt-1">
    <li
      class="list-group-item padding2"
      v-for="(p, index) in sorted_players"
      :key="p"
    >
      <div class="row d-flex align-items-center hoverblue border rounded">
        <div class="col d-flex justify-content-around">
          <i
            class="bi bi-trash text-danger"
            v-if="p.id == selected_player"
            @click="deletePlayer(p.id, p.team_id)"
          ></i>
          {{ index + 1 }}
          <i
            class="bi bi-x-lg text-primary"
            v-if="p.id == selected_player"
            @click="selectPlayer(p.id)"
          ></i>
        </div>
        <div class="col">
          <ProfilePic :player="p" @pic-updated="fetchPlayers()"></ProfilePic>
        </div>
        <div class="col-3">
          <span
            class="bg-warning border rounded"
            v-if="msg && selected_player == p.id"
            >{{ msg }}</span
          >
          <span
            class="border rounded d-flex align-items-center"
            @click="selectPlayer(p.id)"
            v-if="p.id != selected_player"
            >{{ p.name }}
            <i
              class="bi bi-circle-fill text-danger float-end"
              v-if="checkForDuplicate(p.name)"
            ></i>
          </span>
          <div v-else class="row">
            <div class="col">
              <EditPlayer
                :player_id="p.id"
                @name-updated="fetchPlayers()"
              ></EditPlayer>
            </div>
          </div>
        </div>
        <div class="col-2">
          <!-- <PlayerPool :player="p" @pool-updated="fetchPlayers()"></PlayerPool> -->
          {{ getPoolName(p.pool_id) }}
          <div class="dropdown" v-if="selected_player == p.id">
            <i
              class="bi bi-chevron-down"
              id="dropdownMenuButton"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            ></i>

            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <li class="dropdown-item" v-for="po in sorted_pools" :key="po">
                <div @click="updatePool(p.id, po.id)">
                  <span
                    v-if="p.pool_id == po.id"
                    class="text-primary fw-bold"
                    >{{ po.name }}</span
                  >
                  <span v-else>{{ po.name }}</span>
                </div>
              </li>
              <li class="dropdown-item">
                <i class="bi bi-trash text-danger" @click="clearPool(p.id)"></i>
              </li>
            </ul>
          </div>
        </div>
        <div class="col text-muted tinytxt">
          <div v-if="p.team_id" class="border rounded">
            <!-- <TeamName :team_id="p.team_id"></TeamName>-->
            {{ getTeamName(p.team_id) }}
          </div>
          <!-- -- {{ all_teams }} -->
        </div>
        <div class="col">
          <PlayerStats
            :stats="p.stats"
            :player_id="p.id"
            @stats-updated="fetchPlayers()"
          ></PlayerStats>
          <!-- {{ p.stats }} -->
        </div>
        <div class="col">
          <i
            class="bi bi-tag"
            v-if="!p.sale_price"
            @click="updateSaleSelect(p.id, 0)"
          ></i>
          <span @click="updateSaleSelect(p.id, p.sale_price)">{{
            formatToIndianCurrency(p.sale_price)
          }}</span>
          <input
            type="text"
            class="form-control"
            v-if="update_sale_player_id == p.id"
            v-model.number="new_sale_price"
            @keyup.enter="updateSalePrice()"
          />
        </div>
      </div>
    </li>
  </ul>
</template>
<script setup>
import supabase from "@/supabase/config";
import ProfilePic from "../player/ProfilePic.vue";
import PlayerPool from "../player/PlayerPool.vue";
import PlayerStats from "../player/PlayerStats.vue";
import PoolCaution from "../player/PoolCaution.vue";
import EditPlayer from "./EditPlayer.vue";
import TeamName from "../../bidder/bidbuttons/TeamName.vue";
import { ref, onMounted, onBeforeMount, computed } from "vue";
import { useStore } from "@/store/index";
const players_list = ref([]);
const selected_player = ref("");
const pools_list = ref([]);
const all_teams = ref([]);
const update_sale_player_id = ref("");
const new_sale_price = ref(0);
const updateSalePrice = async () => {
  const { data, error } = await supabase
    .from("players")
    .update({ sale_price: new_sale_price.value })
    .eq("id", update_sale_player_id.value)
    .select();
  if (!error) {
    updateSaleSelect("", "");
    fetchPlayers();
  }
};
const updateSaleSelect = (id, old_price) => {
  if (update_sale_player_id.value != id) {
    update_sale_player_id.value = id;
    new_sale_price.value = old_price;
  } else {
    update_sale_player_id.value = "";
  }
};
const msg = ref("");
const updatePool = async (player_id, pool_id) => {
  const { data, error } = await supabase
    .from("players")
    .update({ pool_id: pool_id })
    .eq("id", player_id)
    .select();
  if (!error) {
    fetchPlayers();
  }
};
const clearPool = async (player_id) => {
  const { data, error } = await supabase
    .from("players")
    .update({ pool_id: null })
    .eq("id", player_id)
    .select();
  if (!error) {
    fetchPlayers();
  }
};
const selectPlayer = (id) => {
  if (selected_player.value != id) {
    selected_player.value = id;
  } else {
    selected_player.value = "";
  }
};
const search = ref("");
const store = useStore();
onBeforeMount(() => {
  fetchPools();
  fetchTeams();
});
onMounted(() => {
  setTimeout(() => {
    fetchPlayers();
    if (!pools_list.value.length) {
      fetchPools();
      fetchTeams();
    }
  }, 1000);
});
const fetchPools = async () => {
  let { data: pools, error } = await supabase
    .from("pools")
    .select("*")
    .eq("auction_id", store.live_auction);
  pools_list.value = pools;
};
const fetchTeams = async () => {
  let { data: teams, error } = await supabase
    .from("teams")
    .select("*")
    .eq("auction_id", store.live_auction);
  all_teams.value = teams;
};
const fetchPlayers = async () => {
  if (selected_player.value) {
    selected_player.value = "";
  }
  let { data: players, error } = await supabase
    .from("players")
    .select("*")
    .eq("auction_id", store.live_auction);
  players_list.value = players;
};
const sorted_players = computed(() => {
  var arr = [];
  if (!search.value) {
    //this is done to enable search functionality
    players_list.value.forEach((p) => {
      arr.push(p);
    });
  } else {
    players_list.value.forEach((p) => {
      var local_str = "";
      local_str =
        local_str +
        " " +
        p.name +
        " " +
        addPoolName(p.pool_id) +
        " " +
        getTeamName(p.team_id);
      if (p.stats.length) {
        p.stats.forEach((st) => {
          local_str = local_str + " " + st;
        });
      }

      if (search.value.length >= 2) {
        if (compareStrings(search.value, local_str.trim())) {
          arr.push(p);
        }
      }
    });
  }

  var sorted_arr = [];
  sorted_arr = [...arr].sort((a, b) => a.name.localeCompare(b.name));

  return sorted_arr;
});
const addPoolName = (id) => {
  var p_name = "";
  pools_list.value.forEach((p) => {
    if (p.id == id) {
      p_name = p.name;
    }
  });
  return p_name;
};

// const compareStrings = (needle, haystack) => {
//   var found = false;
//   if (haystack.toLowerCase().includes(needle.toLowerCase())) {
//     found = true;
//   }
//   return found;
// };
const compareStrings = (needle, haystack) => {
  const normalizedNeedle = needle.toLowerCase();
  const normalizedHaystack = haystack.toLowerCase().replace(/\s+/g, "");
  return normalizedHaystack.includes(normalizedNeedle);
};

const deletePlayer = async (id, team) => {
  if (team) {
    msg.value = "Sold players cannot be deleted";
    setTimeout(() => {
      msg.value = "";
      selected_player.value = "";
    }, 2000);
  } else {
    const { error } = await supabase.from("players").delete().eq("id", id);
    if (!error) {
      fetchPlayers();
    }
  }
};
const duplicateNameCount = computed(() => {
  const nameCounts = {};

  players_list.value.forEach((player) => {
    const name = player.name;
    nameCounts[name] = (nameCounts[name] || 0) + 1;
  });
  // Count total number of elements with duplicate names
  return players_list.value.filter((player) => nameCounts[player.name] > 1)
    .length;
});

const checkForDuplicate = (name) => {
  var count = 0;
  var duplicate = false;
  players_list.value.forEach((p) => {
    if (p.name === name) {
      count++;
    }
  });
  if (count > 1) {
    duplicate = true;
  }
  return duplicate;
};
const getPoolName = (pool_id) => {
  var name = "";
  pools_list.value.forEach((p) => {
    if (p.id == pool_id) {
      name = p.name;
    }
  });
  return name;
};
const getTeamName = (team_id) => {
  var name = "";
  all_teams.value.forEach((p) => {
    if (p.id == team_id) {
      name = p.name;
    }
  });
  return name;
};
const sorted_pools = computed(() => {
  var arr = [];
  pools_list.value.forEach((p) => {
    arr.push(p);
  });
  var sorted_arr = [];
  sorted_arr = [...arr].sort((a, b) => a.sort - b.sort);
  return sorted_arr;
});
function formatToIndianCurrency(num) {
  if (num) return num.toLocaleString("en-IN");
}
</script>
<style scoped>
.padding2 {
  padding: 2px;
}
.tinytxt {
  font-size: 10px;
}
.hoverblue:hover {
  background-color: lightblue;
}
</style>
